/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  POST: 'CREATE_ADDITIONAL_METADATA',
  PUT: 'UPDATE_ADDITIONAL_METADATA',
  DELETE: 'DELETE_ADDITIONAL_METADATA',
  RESET: 'RESET_ADDITIONAL_METADATA',
  RELOAD: 'RELOAD_ADDITIONAL_METADATA',
};

export const getDraftId = () => `additionalMetadata-${Date.now()}`;

export const additionalMetadataReducer = (state = [], action) => {
  switch (action.type) {
    case types.POST:
      return [...action.payload];
    case types.PUT:
      const newState = [...state];
      const newValues = { ...newState[0].values, ...action.payload };
      newState[0].values = newValues;
      return newState;
    case types.DELETE:
      return [];
    case types.RELOAD:
      return action.payload;
    case types.RESET:
      return [];
    default:
      return state;
  }
};
